export function transferir(fetch, dados, controller) {
  return fetch().post("/caixatransferencia/transferir", dados, {
    signal: controller.signal
  });
}

export function receber(fetch, dados) {
  return fetch().post(`/caixatransferencia/receber`, dados);
}

export function rejeitar(fetch, id) {
  return fetch().post(`/caixatransferencia/cancelar/${id}`, {});
}

export function obterPendentes(fetch) {
  return fetch().post("/caixatransferencia/get/pend", {});
}

export function obterById(fetch, id) {
  return fetch().post(`/caixatransferencia/get/${id}`, {});
}